/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    ClientWebSocketService: {
        applicationWasUpdated: {
            link: "Click here to reload the application.",
            title: "Application was updated"
        },
        sessionTerminated: {
            link: "Click here to reload the application.",
            title: "Your session was terminated"
        }
    },
    ConnectionsListPage: {
        connectTS: "Socket",
        displayName: "Name",
        navigationTS: "Navigation",
        page: "Current page",
        rooms: "Room(s)",
        serverInstanceUid: "Server",
        sessionTS: "Session",
        userUid: "Login"
    }
};